export interface MapPlayer {
  name: string;
  x: number;
  y: number;
}

/**
 * The other players the world map draws: those in sight, live, and for an
 * admin those `admin_players` last listed in the zone, the live tile winning
 * for a player in both. Friends are drawn apart (green), so left out here.
 */
export function mapPlayers(
  seen: readonly MapPlayer[],
  listed: readonly MapPlayer[],
  friends: readonly { name: string }[],
): MapPlayer[] {
  const byName = new Map<string, MapPlayer>();
  for (const player of listed) byName.set(player.name.toLowerCase(), player);
  for (const player of seen) byName.set(player.name.toLowerCase(), player);
  for (const friend of friends) byName.delete(friend.name.toLowerCase());
  return [...byName.values()].sort((a, b) => a.name.localeCompare(b.name));
}
